import { CustomRoute } from "@/interfaces";
import { FilePlus2, FileText, LayoutDashboard, Users } from "lucide-react";
import React from "react";

const Dashboard = React.lazy(() => import("../modules/SuperAdmin/Dashboard"));
const EditProfile = React.lazy(() => import("../modules/Profile/EditProfile"));
const AllNotifications = React.lazy(() => import("../modules/Notifications/AllNotifications"));
const CreateEditBill = React.lazy(() => import("../modules/Client/CreateEditBill"));
const AllBills = React.lazy(() => import("../modules/Client/AllBills"));

const vendorRoutes: CustomRoute[] = [
  {
    path: "/",
    id: "Vendor",
    element: <Dashboard />,
    menuName: "Dashboard",
    icon: LayoutDashboard,
    highlightOn: ["dashboard"],
  },
  {
    path: "/notifications",
    id: "Vendor",
    element: <AllNotifications />,
    menuName: "Notifications",
    hideInMenu: true,
    highlightOn: ["notifications"],
  },
  {
    path: "/profile",
    id: "Vendor",
    element: <EditProfile />,
    menuName: "Profile",
    icon: Users,
    highlightOn: ["profile"],
  },
  {
    path: "/bills",
    id: "Vendor",
    element: <AllBills />,
    menuName: "All Bills",
    icon: FileText,
    highlightOn: ["bills"],
  },
  {
    path: "/create-bill",
    id: "Vendor",
    element: <CreateEditBill />,
    menuName: "Create Bill",
    icon: FilePlus2,
    highlightOn: ["create-bill"],
  },
];

export default vendorRoutes;
